import axios from 'axios';

/**
 * Loads Keycloak configuration dynamically.
 *
 * Dynamic import helps reduce the initial bundle size
 * by loading the Keycloak config only when required.
 */
const getKeycloakConfig = async () => {
  const keycloak = await import('@/lib/plugins/keycloak-config');

  const { authServerUrl, realm, authenticated } = keycloak.default;

  return {
    /**
     * Base Keycloak realm endpoint
     * Example:
     * https://auth.example.com/realms/my-realm
     */
    baseURL: `${authServerUrl}realms/${realm}`,

    /**
     * Current authentication state
     */
    authenticated,
  };
};

/**
 * Returns current date in YYYY-MM-DD format.
 *
 * Example:
 * 2026-05-11
 */
const getCurrentDate = (): string => {
  return new Date().toISOString().split('T')[0];
};

/**
 * Updates the user's `firstLoginAt` custom attribute.
 *
 * Keycloak custom attributes are stored as string arrays,
 * therefore the value is wrapped inside an array.
 *
 * @param profile - Existing user profile object
 */
export const updateFirstLoginAt = async (profile: any) => {
  const payload = {
    ...profile,
    attributes: {
      ...profile.attributes,

      /**
       * Stores the first login date in YYYY-MM-DD format
       */
      firstLoginAt: [getCurrentDate()],
    },
  };

  return updateUserProfile(payload);
};

/**
 * Updates the Keycloak user profile.
 *
 * @param payload - Updated profile payload
 */
export const updateUserProfile = async (payload: any) => {
  const { baseURL } = await getKeycloakConfig();

  return axios.post(`${baseURL}/account`, payload);
};